export function dataTag(tag = ''): string {
  return `${tag?.replace(/\s+/g, '-').toLowerCase()}`;
}
